// Generated file : do not modify
import { MetaValue } from '@/extend/classes/MetaAttrib';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Sociétés
export default class Societe  {
  // Identifiant unique
  public id: number;
  // 
  public formeJuridiqueId: number;
  // Raison sociale de la société
  public nom: string;
  // Nom usuel
  public alias: string;
  // Numéro SIREN
  public siren: string;
  // Effectif
  public trancheEffectifId: number;
  // Association
  public association: boolean;
  // Identifiant association
  public identAssociation: string;
  // Méta-attributs
  public metaValues: MetaValue[];
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.formeJuridiqueId = 0;
    this.nom = '';
    this.alias = '';
    this.siren = '';
    this.trancheEffectifId = 0;
    this.association = false;
    this.identAssociation = '';
    this.metaValues = [];
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Societe): Societe {
    const newSociete: Societe = new Societe();
    newSociete.id = obj.id;
    newSociete.formeJuridiqueId = obj.formeJuridiqueId;
    newSociete.nom = obj.nom;
    newSociete.alias = obj.alias;
    newSociete.siren = obj.siren;
    newSociete.trancheEffectifId = obj.trancheEffectifId;
    newSociete.association = obj.association;
    newSociete.identAssociation = obj.identAssociation;
    newSociete.metaValues = JSON.parse(JSON.stringify(obj.metaValues));
    newSociete.canUpdate = obj.canUpdate;
    newSociete.canDelete = obj.canDelete;
    newSociete.display = obj.display;
    newSociete.notifDefType = obj.notifDefType;
    return newSociete;
  }

  public toJsonSociete (): string {
    const json = {
      formeJuridiqueId: this.formeJuridiqueId,
      nom: this.nom,
      alias: this.alias,
      siren: this.siren,
      trancheEffectifId: this.trancheEffectifId,
      association: this.association,
      identAssociation: this.identAssociation,
      metaValues: this.metaValues,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromSociete (obj: Societe): void {
    this.id = obj.id;
    this.formeJuridiqueId = obj.formeJuridiqueId;
    this.nom = obj.nom;
    this.alias = obj.alias;
    this.siren = obj.siren;
    this.trancheEffectifId = obj.trancheEffectifId;
    this.association = obj.association;
    this.identAssociation = obj.identAssociation;
    this.metaValues = obj.metaValues;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareSociete (value: Societe): boolean {
    return (this.toJsonSociete() == value.toJsonSociete());
  }

  public cloneSociete (): Societe {
    return Societe.fromJson(this);
  }

  public create (): Promise<Societe> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/societes/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromSociete(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public update (): Promise<Societe> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/societes/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromSociete(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public delete (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/societes/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/societes/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Societe> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Societes/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Societe.fromJson(listData.reccords[0] as Societe);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(societes: Societe[]) {
  }
}
